export default __webpack_public_path__ + "static/media/chevron-right-solid.02542060.svg";